<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg viewBox="0 0 24 24" {...rest} width={size * 4} height={size * 4} class={className}>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M6.69997 15.2825C7.08997 15.6725 7.71997 15.6725 8.10997 15.2825L12 11.4125L15.88 15.2925C16.27 15.6825 16.9 15.6825 17.29 15.2925C17.68 14.9025 17.68 14.2725 17.29 13.8825L12.7 9.2925C12.31 8.9025 11.68 8.9025 11.29 9.2925L6.69997 13.8725C6.30997 14.2625 6.30997 14.8925 6.69997 15.2825Z"
    fill="currentColor"
  />
</svg>
